import type { MarketingRTBRec } from './marketingSendRTB';

declare const window: Window & {
    dataLayer?: Object[];
};

export function marketingSendCriteo(p: MarketingRTBRec) {
    if (! window.dataLayer) window.dataLayer = [];
    const dlp = window.dataLayer.push.bind(window.dataLayer);

    const email = p.userId;

    if (p.type === 'home') {
        dlp({
            event: 'crto_homepage',
            crto: { email }
        });
    }

    if (p.type === 'card') {
        dlp({
            event: 'crto_productpage',
            crto: { email, products: [ p.offerId ] }
        });
    }

    if (p.type === 'search') {
        dlp({
            event: 'crto_listingpage',
            crto: { email, products: p.offerIds ?? [] }
        });
    }
}
